module.exports = __webpack_public_path__ + "img/Course01.c067992a.png";